export const VERSION = '0.0.0';
export const DEBUG_INFO_ENABLED = false;
export const SERVER_API_URL = '';
export const STS_API_URL = 'sts';
export const BUILD_TIMESTAMP = 0;
export const STS_CLIENT = 'admin_a1295597';
export const STS_SECRET = '123456';
export const DASHBOARD_IMAGE_DIR = '/assets/images/customer-dashboard-images';
